export const ElevationPrimitives = {
  none: "none",
  xs: "0px 0px 2px 0px rgba(18, 18, 18, 0.12), 0px 1px 2px 0px rgba(18, 18, 18, 0.14)",
  sm: "0px 2px 8px 0px rgba(0, 0, 0, 0.08)",
  md: "0px 0px 2px 0px rgba(18, 18, 18, 0.12), 0px 2px 4px 0px rgba(18, 18, 18, 0.14)",
  lg: "0px 0px 2px 0px rgba(18, 18, 18, 0.12), 0px 4px 8px 0px rgba(18, 18, 18, 0.14)",
  xl: "0px 8px 24px 0px rgba(18, 18, 18, 0.12)",
};
